
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWind3 as ObiWind3Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-3.js';
 
 
 

 
 export const ObiWind3 = createComponent({
   react: React,
   tagName: 'obi-wind-3',
   elementClass: ObiWind3Element,
   events: {
     
   }
  });
 
 